import { z } from 'zod';
import { validatedGet, validatedPost, validatedPut, validatedDelete } from '../api-client.ts';
import { ImpresaSchema, LavoratoreCompletoSchema } from '@/types/entities/index.ts';
import { OkResult } from './shared.ts';

const RicercaResult = z.object({
  risultati: z.array(ImpresaSchema),
  count: z.number(),
});

const LavoratoriResult = z.object({
  risultati: z.array(LavoratoreCompletoSchema),
  count: z.number(),
});

const ListaImpreseResult = z.object({
  imprese: z.array(ImpresaSchema),
  count: z.number(),
  page: z.number(),
  pageSize: z.number(),
  totalPages: z.number(),
});

interface ListaImpreseParams {
  [key: string]: string | number | undefined;
  page?: number;
  limit?: number;
  sort?: string;
  sortDir?: 'asc' | 'desc';
  q?: string;
  cassa?: string;
  ragioneSociale?: string; ragioneSocialeOp?: string;
  codiceFiscale?: string; codiceFiscaleOp?: string;
  partitaIva?: string; partitaIvaOp?: string;
  codImp?: string; codImpOp?: string;
  citta?: string; cittaOp?: string;
  provincia?: string; provinciaOp?: string;
  indirizzo?: string; indirizzoOp?: string;
  dataIscrizione?: string; dataIscrizioneOp?: string;
  dataIscrizioneDa?: string; dataIscrizioneA?: string;
  dataCessazione?: string; dataCessazioneOp?: string;
  dataCessazioneDa?: string; dataCessazioneA?: string;
}

export const impreseApi = {
  lista: (params: ListaImpreseParams = {}) => {
    const qs = new URLSearchParams();
    for (const [k, v] of Object.entries(params)) {
      if (v !== undefined && v !== '') qs.set(k, String(v));
    }
    const url = `imprese/lista${qs.toString() ? '?' + qs.toString() : ''}`;
    return validatedGet(url, ListaImpreseResult);
  },

  cerca: (q: string, limit = 50) =>
    validatedGet(`imprese?q=${encodeURIComponent(q)}&limit=${limit}`, RicercaResult),

  dettaglio: (id: number) =>
    validatedGet(`imprese/${id}`, ImpresaSchema),

  crea: (dati: Record<string, unknown>) =>
    validatedPost('imprese', dati, ImpresaSchema),

  aggiorna: (id: number, dati: Record<string, unknown>) =>
    validatedPut(`imprese/${id}`, dati, ImpresaSchema),

  elimina: (id: number) =>
    validatedDelete(`imprese/${id}`, OkResult),

  lavoratori: (id: number) =>
    validatedGet(`imprese/${id}/lavoratori`, LavoratoriResult),
};
